export const allPlayers=(players=[],action)=>{
    if(action.type==="FETCH_PLAYERS"){
        return action.payload;
    }
    return players;
}

export const selectedPlayers=(players={},action)=>{
    if(action.type==="SELECTED_PLAYERS"){
        return action.payload;
    }
    if(action.type==="REFACTOR_PLAYERS"){
        const newPlayers=Object.assign({},players);
         newPlayers.players=action.payload;
         return newPlayers;
    }
    return players;
}